<template>
	<div class="modal-body form form-horizontal">
		<!-- CREAR -->
		<div class="row">
			<!-- DATOS DEL POSTULANTE -->
			<div class="col-md-12">
				<h5>Datos del postulante</h5>
			</div>
			<!-- TIPO DE DOC. -->
			<div class="col-md-6">
				<label class="col-form-label label-modal" for="business_id">Tipo de Doc.</label>
				<p>{{ propInfo.data.row.document_type_name }}</p>
			</div>
			<!-- NUMERO DE DOCUMENTO -->
			<div class="col-md-6">
				<label class="col-form-label label-modal">Número de Doc.</label>
				<p>{{ propInfo.data.row.document_number }}</p>
			</div>
			<!-- NOMBRES COMPLETOS -->
			<div class="col-md-12">
				<label class="col-form-label label-modal">Apellidos y nombres</label>
				<p>{{ propInfo.data.row.full_names }}</p>
			</div>
			<!-- CELULAR -->
			<div class="col-md-4">
				<label class="col-form-label label-modal">Celular</label>
				<p>{{ propInfo.data.row.cellphone }}</p>
			</div>
			<!-- EMAIL -->
			<div class="col-md-8">
				<label class="col-form-label label-modal">Correo</label>
				<p>{{ propInfo.data.row.email }}</p>
			</div>
			<!-- PROGRAMACION -->
			<div class="col-md-12 mt-3">
				<h5>Programación del examen médico</h5>
			</div>
			<!-- TIPO DE EXAMEN MEDICO -->
			<div class="col-md-12 form-group">
				<label class="col-form-label label-modal">Tipo de examen médico</label>
				<select name="exam_type_id" v-model="exam_type_id" class="form-control form-control-sm" v-validate="'required'" data-vv-as="'Tipo de examen médico'">
					<option :value="null">Seleccionar</option>
					<option :value="item.id" v-for="(item, index) in exam_types" :key="index">{{ item.name }}</option>
				</select>
				<span v-show="errors.has('exam_type_id')" class="form-group__error"> <i class="fas fa-exclamation-circle"></i> {{ errors.first('exam_type_id') }} </span>
			</div>
			<!-- CENTRO CLINICA -->
			<div class="col-md-12 form-group">
				<label class="col-form-label label-modal">Centro clinico</label>
				<select name="place_id" v-model="place_id" class="form-control form-control-sm" v-validate="'required'" data-vv-as="'Tipo de examen médico'">
					<option :value="null">Seleccionar</option>
					<option :value="item.id" v-for="(item, index) in places" :key="index">{{ item.name }}</option>
				</select>
				<span v-show="errors.has('place_id')" class="form-group__error"> <i class="fas fa-exclamation-circle"></i> {{ errors.first('place_id') }} </span>
			</div>
			<!-- FECHA Y HORA -->
			<div class="col-md-8 form-group">
				<label class="col-form-label label-modal">Fecha y hora</label>
				<flat-pickr
					v-model="date"
					:config="{
						minDate: new Date(),
						enableTime: true,
						time_24hr: false,
						dateFormat: 'Y-m-d H:i:S',
						altFormat: 'j F, Y - G:i K',
					}"
					class="form-control form-control-sm flatpickr-input"
					placeholder="Seleccionar"
					name="date"
					v-validate="'required'"
					data-vv-as="'Fecha y hora de la entrevista'"></flat-pickr>

				<span v-show="errors.has('date')" class="form-group__error"> <i class="fas fa-exclamation-circle"></i> {{ errors.first('date') }} </span>
			</div>
			<!-- ANTIGENICA -->
			<div class="col-md-4 form-group align-self-end">
				<div class="form-check">
					<input class="form-check-input" type="checkbox" v-model="antigen" value="1" name="antigen" id="defaultCheck1" />
					<label class="form-check-label" for="defaultCheck1">Antígeno</label>
				</div>
			</div>
		</div>

		<div class="row mt-5">
			<div class="col-12 d-flex justify-content-end">
				<button @click="mtd_send" class="btn btn-primary mr-3">{{ propInfo.data.buttonSubmit }}</button>
				<button @click="mtd_close" class="btn btn-secondary">Cancelar</button>
			</div>
		</div>
	</div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
export default {
	props: {
		propInfo: {
			required: true,
		},
		modal_id: {
			required: true,
		},
	},
	data() {
		return {
			exam_types: [],
			places: [],
			exam_type_id: null,
			place_id: null,
			date: null,
			antigen: null,
			errorsBackend: {},
			methods: {
				init: {
					definition: 'this.mtd_onDefinition()',
					update: 'this.mtd_onDefinition()',
				},
				action: {
					definition: 'this.mtd_store()',
					update: 'this.mtd_update()',
				},
			},
		};
	},

	computed: {
		...mapGetters(['url_api']),
		cpd_btnDisabled() {
			return this.errors.any();
		},
	},
	mounted() {
		eval(this.methods.init[this.propInfo.data.method]);
	},
	methods: {
		...mapActions(['get', 'post', 'update']),
		mtd_onDefinition() {
			this.get({
				url: this.url_api + '/medical_exam/requirements',
			})
				.then(response => {
					this.exam_types = response.exam_types;
					this.places = response.places;
				})
				.catch(() => {});
			this.mtd_definition();
		},
		mtd_definition() {
			this.$emit('onload', { status: 'success' });
		},
		mtd_store: function () {
			this.$swal
				.fire({
					icon: 'question',
					title: '¿Estás seguro que desea programar el Examen Medico?',
					showCancelButton: true,
					confirmButtonText: 'Sí, confirmar',
				})
				.then(result => {
					if (result.isConfirmed) {
						this.post({
							url: `${this.url_api}/medical_exam/${this.propInfo.data.row.postulation_step_id}/store`,
							params: { exam_type_id: this.exam_type_id, place_id: this.place_id, date: this.date, antigen: this.antigen },
						}).then(res => {
							if (res.state == 'success') {
								this.$emit('success', {
									component: 'medical-exam-programming-modal',
									data: { i: this.propInfo.data.i, index: this.propInfo.data.index, exam: res.exam },
									action: 'store',
									modal_id: 'medical-exam-programming-modal',
								});
								this.$swal.fire({
									icon: 'success',
									title: `Fecha registrada correctamente para la 'Examen Medico'`,
									showCancelButton: false,
								});
							}
						});
					}
				});
		},
		mtd_update: function () {
			this.$swal
				.fire({
					icon: 'question',
					title: '¿Estás seguro que desea reprogramar el Examen Medico?',
					showCancelButton: true,
					confirmButtonText: 'Sí, confirmar',
				})
				.then(result => {
					if (result.isConfirmed) {
						this.post({
							url: `${this.url_api}/medical_exam/${this.propInfo.data.row.postulation_step_id}/exam_update`,
							params: { exam_id: this.propInfo.data.row.exam.id, exam_type_id: this.exam_type_id, place_id: this.place_id, date: this.date, antigen: this.antigen },
						}).then(res => {
							if (res.state == 'success') {
								this.$emit('success', {
									component: 'medical-exam-programming-modal',
									data: { i: this.propInfo.data.i, index: this.propInfo.data.index, exam: res.exam },
									action: 'store',
									modal_id: 'medical-exam-programming-modal',
								});
								this.$swal.fire({
									icon: 'success',
									title: `Fecha registrada correctamente para el 'Examen Medico'`,
									showCancelButton: false,
								});
							}
						});
					}
				});
		},
		$eval(expr) {
			return eval(expr);
		},
		mtd_close: function () {
			this.$emit('close');
		},
		mtd_send: function () {
			this.submitted = true;
			var _this = this;
			this.$validator.validate().then(valid => {
				if (valid) {
					_this.$eval(_this.methods.action[this.propInfo.data.method]);
				}
			});
		},
	},
};
</script>
